// extracted by mini-css-extract-plugin
export default {"main_container":"home_main_container__mTgS2","layout":"home_layout__jOrP3","products_heading":"home_products_heading__ydNqH","products_container":"home_products_container__RgzAO"};